// extracted by mini-css-extract-plugin
export default {"item":"Item_item__vwmWB","title":"Item_title__JqKCo","pointer":"Item_pointer__8s-X8","isSelected":"Item_isSelected__slgkO"};